export default __webpack_public_path__ + "static/media/orthopedic.cd296030.jpg";